import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutTriumphPayStatusLookup extends Layout {
    sourceInterfaceCodeLookup: DataSource;
    tableInterfaceCodeLookup: Table;
}
